import { useState } from "react";
import { NetFlowsCard } from "~/modules/visualization/components/NetFlowsChart/NetFlowsCard";
import type { NetFlowsItemLabels } from "~/modules/visualization/components/NetFlowsChart/component";
import { NetFlowsData } from "~/modules/fund_flows/api/queryNetFlows";
import type { ColumnSpanConfig } from "~/types";
import { NET_FLOW_ASSET_LEGEND_WIDTH } from "./consts";
import { ButtonGroup } from "~/components/ButtonGroup";

// // // //

type NetFlowsGroup = "asset" | "assetClass" | "manager";

export function HomeNetFlowsCard(props: {
    colSpans?: ColumnSpanConfig;
    netFlowsByAssetClass: NetFlowsData;
    netFlowsByAsset: NetFlowsData;
    netFlowsByManager: NetFlowsData;
    netFlowAssetLabels: NetFlowsItemLabels;
}) {
    const {
        colSpans,
        netFlowsByAssetClass,
        netFlowsByAsset,
        netFlowsByManager,
        netFlowAssetLabels,
    } = props;
    const [group, setGroup] = useState<NetFlowsGroup>("asset");
    const isAssetGroup = group === "asset";
    const netFlowsByGroup: Record<NetFlowsGroup, NetFlowsData> = {
        asset: netFlowsByAsset,
        assetClass: netFlowsByAssetClass,
        manager: netFlowsByManager,
    };

    return (
        <NetFlowsCard
            title="Net Flows"
            cardClassName="lg:order-0"
            colSpans={colSpans}
            netFlows={netFlowsByGroup[group]}
            itemLabels={isAssetGroup ? netFlowAssetLabels : undefined}
            legendWidth={NET_FLOW_ASSET_LEGEND_WIDTH}
            showInfoTooltip={false}
            headerControls={
                <ButtonGroup
                    title="Group by"
                    value={group}
                    options={[
                        {
                            label: "Asset",
                            value: "asset",
                            testID: "net-flows-group--asset",
                        },
                        {
                            label: "Asset Class",
                            value: "assetClass",
                            testID: "net-flows-group--asset-class",
                        },
                        {
                            label: "Manager",
                            value: "manager",
                            testID: "net-flows-group--manager",
                        },
                    ]}
                    onValueChange={(value) => setGroup(value as NetFlowsGroup)}
                />
            }
        />
    );
}
